import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import IsNotActive from "../components/IsNotActive/IsNotActive";
import { indexStore } from "../store/indexStore";
import { Header } from "../components/header";
import Visibility from "../components/utils/Visibility";
import { Skeleton } from "../components/ui/skeleton";
import Iterator from "../components/utils/Iterator";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { CiLocationOn } from "react-icons/ci";
import BranchModel from "../Models/BranchModel";
import RestaurantModel from "../Models/RestaurantModel";

function Restaurant() {
  const { domain } = useParams();
  const {
    name,
    fetchBranchesAction,
    branchesLoading,
    branches,
    description,
    restaurant,
  } = indexStore();

  useEffect(() => {
    fetchBranchesAction({ domain: domain });
  }, []);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const onClickBranch = (id: number) => {
    navigate(`${id}`);
  };

  const nameKey = name as keyof RestaurantModel;

  return (
    <IsNotActive>
      <title>{domain?.toUpperCase()}</title>
      <Header backgroundColorfull noBack={true} />
      <Visibility visible={!branchesLoading}>
        <section className="flex flex-col gap-5 flex-grow text-onBackground">
          {/* ✅ ترويسة ملونة بهوية المطعم */}
          <div className="bg-primary text-onPrimary p-6 rounded-b-2xl shadow-md flex flex-col gap-3 items-center text-center">
            <p className="text-3xl font-extrabold">
              {t("gloabl.welcome")}{" "}
              {typeof restaurant[nameKey] === "string"
                ? String(restaurant[nameKey] || "").toUpperCase()
                : restaurant[nameKey] ?? ""}
            </p>
            <p className="text-lg opacity-90">{t("gloabl.ourBranches")}</p>
          </div>

          {/* ✅ قائمة الفروع */}
          <div className="grid md:grid-cols-2 gap-5 p-4 pb-20">
            <Iterator
              data={branches}
              render={(branch) => (
                <BranchCard
                  key={branch.id}
                  branch={branch}
                  onClick={onClickBranch}
                  name={name as keyof BranchModel}
                  description={description as keyof BranchModel}
                />
              )}
            />
          </div>
        </section>
      </Visibility>
      <Visibility visible={branchesLoading}>
        <RenderLoading />
      </Visibility>
    </IsNotActive>
  );
}

export default Restaurant;

const RenderLoading = () => (
  <div>
    <Skeleton />
  </div>
);

const BranchCard = ({
  branch,
  onClick,
  name,
  description,
}: {
  branch: BranchModel;
  onClick: (id: number) => void;
  name: keyof BranchModel;
  description: keyof BranchModel;
}) => {
  return (
    <div
      key={branch.id}
      className="flex flex-col gap-3 p-5 shadow-md border rounded-lg cursor-pointer transition hover:shadow-lg hover:border-primary"
      onClick={() => onClick(branch.id)}
    >
      <p className="text-xl font-bold text-primary">
        <p className="text-xl font-bold text-primary">
          {typeof branch[name] === "string"
            ? String(branch[name]).toUpperCase()
            : branch[name]}
        </p>{" "}
      </p>
      <p className="text-base font-medium">{branch[description]}</p>

      <p className="text-sm font-semibold flex gap-2 items-center">
        <CiLocationOn className="text-primary" />
        {branch[name === "name_ar" ? "address_ar" : "address_en"]}
      </p>

      <Visibility visible={branch.phone !== ""}>
        <div className="flex gap-2 items-center text-sm">
          <MdOutlinePhoneInTalk className="text-primary" />
          <p dir="ltr">{branch.phone}</p>
        </div>
      </Visibility>

      <Visibility visible={branch.mobile !== ""}>
        <div className="flex gap-2 items-center text-sm">
          <IoPhonePortraitOutline className="text-primary" />
          <p dir="ltr">{branch.mobile}</p>
        </div>
      </Visibility>
    </div>
  );
};
